import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { EmptyState, FlexRow, WebsiteChipItem } from "@similarweb/ui-components";

import { CenteredFlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const StyledEmptyState = styled(EmptyState)`
    padding: 40px;
    border-radius: 6px;
    background-color: ${colorsPalettes.carbon[0]};
    box-shadow: 0px 3px 6px 0px rgba(14, 30, 62, 0.08);
`;
export const Hr = styled.hr`
    margin: 24px 0;
    width: 100%;
    background-color: ${colorsPalettes.carbon[100]};
`;
export const FooterContainer = styled(CenteredFlexColumn)`
    gap: 16px;
`;
export const ButtonsContainer = styled(FlexRow)`
    gap: 16px;
`;
export const LayoutContainer = styled(CenteredFlexColumn)`
    width: 100%;
`;
export const StyledWebsiteChipItem = styled(WebsiteChipItem)`
    cursor: pointer;
    border-radius: 8px;
    margin: 0;
`;

const VSWrapper = styled(FlexRow)`
    ${setFontVariant("body1", colorsPalettes.carbon[300])};
    letter-spacing: 0.7px;
    margin-right: 8px;
    margin-left: 8px;
    flex: 0 0 auto;
    height: 32px;
    align-items: center;
`;
